
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.946 10.78l-7-4.045A.636.636 0 000 7.283v3.258h3.237a.785.785 0 110 1.57H0v3.26a.637.637 0 00.973.531l6.978-4.028a.636.636 0 000-1.095M7.515 5.457a.785.785 0 110-1.57.785.785 0 010 1.57zm2.527-1.57h.678V.63a.636.636 0 00-.947-.548l-7 4.043a.636.636 0 00.01 1.1l6.994 4.037a.637.637 0 00.947-.566v-3.24h-.678a.785.785 0 010-1.57"}})])
          )
        }
      }
    